<template>
  <div
    class="text-center "
    style="max-width: 480px;"
  >
    <div class="my-3 position-relative">
      <section
        id="turntable"
        class="gb-turntable d-flex align-items-center"
        :style="cssprops"
      >
        <!-- <svg width="30" height="60" viewBox="0 0 8 16"
          class="map"
          style="z-index: 10">
        <path
          d="M9,4C6.789,4,5,4.125,5,6.667,5,11.333,9,20,9,20s4-8.667,4-13.333C13,4.116,11.211,4,9,4Z"
          transform="translate(-5 -4)"/>
      </svg> -->

        <!-- <svg width="56" height="88" viewBox="0 0 56 88"
          class="map">
        <defs>
          <filter id="路径_4" x="0" y="0" filterUnits="userSpaceOnUse">
            <feOffset dy="-1" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="4" result="blur"/>
            <feFlood flood-opacity="0.25"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
        </defs>
        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#路径_4)">
          <path id="路径_4-2" data-name="路径 4" d="M20,4C11.707,4,5,4.468,5,14,5,31.5,20,64,20,64S35,31.5,35,14C35,4.433,28.293,4,20,4Z" transform="translate(7 9)"/>
        </g>
      </svg> -->

        <svg
          id="layer_1"
          data-name="layer 1"
          width="28"
          height="56"
          viewBox="0 0 30 56"
          class="map"
        >
          <path
            id="path_4-2"
            data-name="path 4-2"
            d="M15,0C6.7,0,0,.5,0,9.7,0,23.5,9.9,46.8,13.6,55.1a1.5,1.5,0,0,0,2.8,0C20.1,46.8,30,23.5,30,9.7,30,.4,23.3,0,15,0Z"
          />
        </svg>

        <div class="gb-turntable-container">
          <canvas
            class="gb-turntable-canvas"
            width="300"
            height="300px"
          >抱歉！瀏覽器不支持。</canvas>
        </div>
        <a
          id="turntablebtn"
          class="gb-turntable-btn"
          href="javascript:;"
          @click="playroulette()"
        ><font :color="buttoncolor">START</font></a>
      </section>
      <img
        v-if="bgDisplayImg !== ''"
        :src="bgDisplayImg"
        alt=""
        class="position-absolute"
        style="left:-2px;bottom:-2px;z-index:30;pointer-events: none;"
      >
    </div>
    <b-button
      class="w-100 border-0 font-weight-bold"
      :disabled="finished"
      :style="`background: rgba(${buttonColor}, 1.0); color: rgba(${buttonColor === '255,255,255' ? '0,0,0' : '255,255,255'},1.0);`"
      @click="playroulette()"
    >
      {{ buttonWording }}
    </b-button>
  </div>
</template>

<script>
import '@/assets/Roulette/js/GB-canvas-turntable';

export default {
  props: {
    // 輪盤樣式(暫時沒做)
    // colorType: {
    //   type: Number,
    //   required: true,
    // },
    color: {
      type: String,
      require: true,
    },
    buttonWording: {
      type: String,
      required: true,
    },
    buttonColor: {
      type: String,
      required: true,
    },
    bgDisplayImg: {
      type: String,
      required: true,
    },
    // 獎品
    item: {
      type: Object,
      required: true,
    },
    itemlist: {
      type: Array,
      required: true,
    },
    // 是否可以玩
    isPlay: {
      type: Boolean,
      default: false,
    },
    activityconfirmpopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pathcolor: '',
      btncolor: '',
      turntablecolor: '',
      finished: false,
    };
  },
  computed: {
    cssprops() {
      return { '--path-color': this.pathcolor, '--btn-color': this.btncolor, '--turntable-color': this.turntablecolor };
    },
    reloadcolor() {
      return this.color;
    },
    buttoncolor() {
      return this.color === '255,255,255' ? 'black' : 'white';
    },
  },
  watch: {
    isPlay() {
      if (this.isPlay && this.activityconfirmpopup) {
        this.finished = true;
        window.gbTurntable.run();
      }
    },
    reloadcolor() {
      this.reloadtruntable(false);
    },
  },
  mounted() {
    this.reloadtruntable(true);
  },
  methods: {
    RGBtoHex(color) {
      const rgb = color.split(',');
      const redValue = Number(rgb[0]).toString(16);
      const greenValue = Number(rgb[1]).toString(16);
      const blueValue = Number(rgb[2]).toString(16);
      this.maincolor = `#${redValue}${greenValue}${blueValue}`;
    },
    reloadtruntable() {
      this.RGBtoHex(this.reloadcolor);
      const vm = this;
      let tempcolor = vm.maincolor;
      if (vm.maincolor === '#ffffff') { tempcolor = '#E9ECEF'; } else if (vm.maincolor === '#000') { tempcolor = '#343A40'; }
      window.gbTurntable.init({
        id: 'turntable',
        config(callback) {
        // 获取奖品信息
        // callback && callback(['11元紅包','2元紅包','3元紅包','4元紅包','5元紅包','6元紅包']);
          callback(
            {
              color: tempcolor,
              wordingcolor: vm.buttoncolor,
              prizes: vm.itemlist,
            },
          );
        },
        getPrize(callback) {
          // 获取中奖信息
          const num = vm.itemlist.findIndex((x) => x.name === vm.item.itemInfo.name); // 奖品ID
          const chances = 0; // 可抽奖次数
          callback([num, chances]);
        },
        gotBack() {
          vm.finished = true;
          vm.$emit('done');
        },
        getcolor(data) {
          const pathcolor = data[2];
          const btncolor = data[0];
          const turntablecolor = data[1];
          vm.pathcolor = pathcolor;
          vm.btncolor = btncolor;
          vm.turntablecolor = turntablecolor;
        },
      });
    },
    playroulette() {
      if (!this.finished) {
        if (!this.isPlay) {
          this.$emit('show');
        } else {
          this.finished = true;
          window.gbTurntable.run();
        }
      }
    },
  },

};
</script>
<style src="@/assets/Roulette/css/GB-canvas-turntable.css"></style>
<style>
.map {left: 136px;top: -30px;}
.gb-turntable-item img { width: 72px; height: 72px;}

</style>
